import React from 'react'

export const supervisorChatSimpleSVG = <svg className="supervisorChatSimpleSVG" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" width="85%" height="85%" viewBox="77 1428 20 22.765">
	<defs>
		<clipPath id="clip-path">
			<path id="Path_553" data-name="Path 553" className="cls-1" d="M0-20.57H20V2.194H0Z" transform="translate(0 20.57)" />
		</clipPath>
	</defs>
	<g id="Group_967" data-name="Group 967" className="cls-2" transform="translate(77 1428)">
		<g id="Group_946" data-name="Group 946" className="cls-3" transform="translate(0 0)">
			<g id="Group_943" data-name="Group 943" transform="translate(0 12.659)">
				<path id="Path_550" data-name="Path 550" d="M1.284,0C.968,5.845-2.032,8.51-2.032,8.51S-5.009,5.806-5.343,0C-8.523.71-12,2.325-12.033,4.728a12,12,0,0,0,10,5.375,11.993,11.993,0,0,0,10-5.375C7.933,2.329,4.461.713,1.284,0" transform="translate(12.033 0.002)" />
			</g>
			<g id="Group_944" data-name="Group 944" transform="translate(5.385 0)">
				<path id="Path_551" data-name="Path 551" d="M.452,0a4.7,4.7,0,1,1,0,9.4,4.7,4.7,0,0,1,0-9.4" transform="translate(4.238 0)" />
			</g>
			<g id="Group_945" data-name="Group 945" transform="translate(8.765 12.261)">
				<path id="Path_552" data-name="Path 552" d="M.085,0-.8,1.2l.635.953L-.8,3.954.085,6.78.431,7.8.792,6.78l.882-2.825-.636-1.8L1.674,1.2.792,0Z" transform="translate(0.799)" />
			</g>
		</g>
	</g>
</svg>

export const supervisorChatSVG = <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	width="100%" height="100%" viewBox="0 0 40 40" enableBackground="new 0 0 40 40" xmlSpace="preserve">
	<g>
		<linearGradient className="supervisorChatIconBorder" id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="32.7842" y1="3.5283" x2="5.7695" y2="35.5194">
			<stop offset="0" style={{ stopColor: "#009FFF" }} />
			<stop offset="0.6111" style={{ stopColor: "#0066CC" }} />
			<stop offset="0.7346" style={{ stopColor: "#005FD3" }} />
			<stop offset="1" style={{ stopColor: "#0055DD" }} />
		</linearGradient>
		<path className="supervisorChatIconBorder" fill="url(#SVGID_2_)" d="M20.244,4.84c-9.323,0-16.884,6.676-16.884,13.516c0,4.273,2.954,9.312,7.447,11.539
		c-0.144,0.669-0.422,1.871-1.869,3.627c-0.451,0.449-0.83,1.091,0.321,1.215c1.215,0.516,5.524,0.035,9.277-2.793
		c0.564,0.041,1.133,0.064,1.707,0.064c9.326,0,16.884-6.816,16.884-13.652C37.128,11.516,29.57,4.84,20.244,4.84z"/>
		<g>
			<path className="supervisorChatIcon" fill="#FFFFFF" d="M22.381,19.24c-0.217,4.023-2.283,5.857-2.283,5.857s-2.049-1.861-2.279-5.859
			c-2.188,0.489-4.581,1.602-4.605,3.257c1.48,2.228,4.017,3.7,6.885,3.7c2.869,0,5.404-1.473,6.884-3.7
			C26.958,20.843,24.568,19.73,22.381,19.24z"/>
			<path className="supervisorChatIcon" fill="#FFFFFF" d="M20.148,10.523c1.791,0,3.237,1.443,3.237,3.234s-1.446,3.236-3.237,3.236
			c-1.786,0-3.229-1.445-3.229-3.236S18.362,10.523,20.148,10.523z"/>
			<polygon className="supervisorChatIcon" fill="#FFFFFF" points="19.855,18.964 19.247,19.791 19.685,20.447 19.247,21.688 19.855,23.632 20.094,24.335
			20.343,23.632 20.949,21.688 20.513,20.447 20.949,19.791 20.343,18.964 		"/>
		</g>
	</g>
</svg>


// WEBPACK FOOTER //
// ./src/Images/ChatSVG.js